import { render, staticRenderFns } from "./SkinGrid.vue?vue&type=template&id=620053aa&scoped=true"
import script from "./SkinGrid.vue?vue&type=script&lang=js"
export * from "./SkinGrid.vue?vue&type=script&lang=js"
import style0 from "./SkinGrid.vue?vue&type=style&index=0&id=620053aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620053aa",
  null
  
)

export default component.exports